import type {
	HTTPValidationError,
	OptimizationGroupReviewCreateModel,
	OptimizationGroupReviewModel,
	OptimizationGroupReviewUpdateModel,
} from '@/shared/generated'

import { useMutation, useQueryClient } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

/**
 * Reviews
 */
export function useCreateReviewMutation() {
	const queryClient = useQueryClient()

	return useMutation<
		OptimizationGroupReviewModel,
		HTTPValidationError,
		{
			optimizationGroupId: string
			body: OptimizationGroupReviewCreateModel
		}
	>({
		mutationFn: (payload) =>
			client.reviews.createOptimizationGroupReview(
				{ optimizationGroupId: payload.optimizationGroupId },
				payload.body
			),
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['reviews'],
			})
		},
	})
}
export function useUpdateReviewMutation() {
	const queryClient = useQueryClient()

	return useMutation<
		OptimizationGroupReviewModel,
		HTTPValidationError,
		{
			optimizationGroupId: string
			body: OptimizationGroupReviewUpdateModel
		}
	>({
		mutationFn: (payload) =>
			client.reviews.updateOptimizationGroupReview(
				{ optimizationGroupId: payload.optimizationGroupId },
				payload.body
			),
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['reviews'],
			})
		},
	})
}
export function useApproveReviewMutation() {
	const queryClient = useQueryClient()

	return useMutation<OptimizationGroupReviewModel, HTTPValidationError, string>(
		{
			mutationFn: (optimizationGroupId) =>
				client.reviews.approveOptimizationGroupReview({ optimizationGroupId }),
			onSuccess() {
				queryClient.invalidateQueries({
					queryKey: ['reviews'],
				})
			},
		}
	)
}
export function useDeleteReviewMutation() {
	const queryClient = useQueryClient()

	return useMutation<void, HTTPValidationError, string>({
		mutationFn: (optimizationGroupId) =>
			client.reviews.deleteOptimizationGroupReview({ optimizationGroupId }),
		onSuccess() {
			queryClient.invalidateQueries({
				queryKey: ['reviews'],
			})
		},
	})
}
